module.exports = __webpack_public_path__ + "img/Phrase Analyser.4e39da1f.svg";